import React from 'react';
import Label from '../../../../ui/label';
import Input from '../../../../ui/input';
import { useDispatch } from 'react-redux';
import { UilUser } from '../../../../../assets/icon/iconify';
import { customStyle, defaultStyle } from '../../../../../constant/custom-style';
import { useMediaQuery } from '../../../../../hooks/common/use-media-query';
import { useIsCompleteProposalAs } from '../../../../../hooks/proposal/use-state-checker-proposal';
import { setAgeByLabel } from '../../../../../features/gms-proposal-forms/gc-tog-ea-mop/gc-tog-ea-mop-slice';
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data';

export default function ClientInputAgeProfile() {

    const dispatch = useDispatch();
    const { ageProfile } = useProposalTypeData()
    const isDesktop = useMediaQuery("(min-width: 1024px)");
    const iconSize: number = isDesktop ? 16 : 15;
    const isComplete = useIsCompleteProposalAs();

    const handleAgeChange = (label: "Minimum Age" | "Max Age") => (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        dispatch(setAgeByLabel({
            label,
            age: value === "" ? null : Number(value)
        }));
    };

    return (
        <div className="">
            <div className="flex space-x-2 items-center mb-1">
                <div className="bg-[#186db233] p-1 rounded">
                    <UilUser width={iconSize} height={iconSize} />
                </div>
                <Label
                    label="Eligibility Age"
                    fontWeight="font-semibold text-gray-800"
                    requiredText=" *"
                    isRequired={true}
                />
            </div>
            <div className="grid grid-cols-2 gap-2">
                {ageProfile.map(item => {
                    const placeholderText = item.label === 'Minimum Age' ? '18' : item.label === 'Max Age' ? '65' : '';
                    const hasValue = item.age !== null && item.age !== undefined;
                    return (
                        <div key={item.label} className="flex flex-col gap-1">
                            <label className="text-xs">
                                {`${item.label}:`}
                            </label>
                            <Input
                                type="number"
                                min={18}
                                max={65}
                                step={1}
                                inputMode="numeric"
                                value={item.age ?? ""}
                                placeholder={placeholderText}
                                isCustomStyle
                                customCss={`${defaultStyle} text-xs placeholder:text-xs ${hasValue ? customStyle : ""}`}
                                onChange={handleAgeChange(item.label)}
                                required
                                disabled={!isComplete}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}